export default __webpack_public_path__ + "static/media/permission_denied.227c0dbd.svg";